module.exports = __webpack_public_path__ + "static/img/day3.07939b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour3/day3.jpg
// module id = SING
// module chunks = 0